import { useTranslation } from "react-i18next";

export default function TypesKrukken() {
  const { t } = useTranslation("raamkruk-vervangen");
  const items = t("typesKrukken.items", { returnObjects: true }) as Array<{
    num: string;
    title: string;
    text: string;
  }>;

  const icons = [
    "ri-arrow-left-right-line",
    "ri-key-2-line",
    "ri-circle-line",
    "ri-door-open-line",
    "ri-door-closed-line",
    "ri-vip-diamond-line",
  ];

  return (
    <section className="bg-white py-16 md:py-24 w-full">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10">
        <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight text-center mb-10 md:mb-14">
          {t("typesKrukken.h2")}
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((item, i) => (
            <div
              key={i}
              className="bg-white border border-brand-border rounded-2xl p-6 md:p-8 hover:border-brand-yellow transition-colors"
            >
              <div className="flex items-start justify-between mb-4">
                <div className="font-geist-mono font-bold text-sm text-brand-yellow bg-brand-yellow/10 px-2.5 py-1 rounded-md">
                  {item.num}
                </div>
                <div className="w-10 h-10 rounded-full bg-brand-cream flex items-center justify-center">
                  <i className={`${icons[i]} text-brand-blue text-lg w-5 h-5 flex items-center justify-center`}></i>
                </div>
              </div>
              <h3 className="font-geist font-bold text-lg text-brand-text mb-1">
                {item.title}
              </h3>
              <p className="font-geist text-sm text-brand-text/70 leading-relaxed">
                {item.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}